export default __webpack_public_path__ + "static/media/Break Regular.713a2872.ttf";